import React, { Component } from 'react';
import { connect } from 'react-redux'; 
import { withTranslation } from 'react-i18next'; 
import { giftCardInitialization } from 'actions/EntityActions';
import DialogInput from 'screens/components/advanced/DialogInput';
import TextInput from 'screens/components/basic/TextInput';
import Button from 'screens/components/basic/Button';
import DialogHeaderWithClose from 'screens/components/basic/DialogHeaderWithClose';

class POSGiftCardinitialization extends Component {
    constructor(props, context) {
        super(props, context);
    }

    giftCardInitialization = () => {
        let p = this.props;
        let model = {
            BranchId: p.branchId,
            ErnexNo: p.ernexNo
        };
        //console.log(model);
        this.props.giftCardInitialization(model);
    }

    render() {
        const { t } = this.props; 
        let p = this.props;
        return (
            <DialogInput
                title={<DialogHeaderWithClose style="pink" text={t('pos.giftCard.initialization.label')} handleClose={() => this.props.onCancel()}/>}
                actions={[
                    <Button
                        key={1}
                        name="buttonRefundDialogCancel"
                        type="Button"
                        className="corner_X"
                        primary={false}
                        onTouchTap={() => this.props.onCancel()} />,
                    <Button
                        key={2}
                        className="pull-right space"
                        name="buttonRefundDialogConfirm"
                        label={t('common.confirm')}
                        primary={true}
                        onTouchTap={() => this.giftCardInitialization()} />]}
                modal={true}
                style={{ zIndex: '980' }}
                open={this.props.show}
                autoScrollBodyContent={true}>
                    <h5>{t('pos.giftCard.initialization.fillUpInfo')}</h5>
                    <div className="row">
                        <div className="col-lg-12">
                            <TextInput name={`${p.name}ErnexNo`}
                                fullWidth={true}
                                label={t('pos.giftCard.ErnexNo.label')}
                                floatingLabelText={t('pos.giftCard.ErnexNo.label')}
                                hintText={t('pos.giftCard.ErnexNo.hintText')} />
                        </div>
                    </div>
            </DialogInput>
        );
    }
}

function mapStateToProps(state, ownProps) {
    return {
        branchId: state.common.branchId,
        ernexNo: state.form[`POSGiftCardinitializationErnexNo`] || '',
    };
}

function mapDispatchToProps(dispatch) {
    return {
        giftCardInitialization: (model) => dispatch(giftCardInitialization(model))
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(POSGiftCardinitialization));